// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"PlotSidebar_sidebar__1Z_kX","sidebarContent":"PlotSidebar_sidebarContent__1ntO3"};